// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Chip,
  Divider,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props {
  title: string;
  chip?: string;
}

export function Card(props: PropsWithChildren<Props>) {
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      sx={{ overflow: 'hidden', boxShadow: theme.shadows[6] }}
    >
      <Stack
        paddingX={2}
        paddingY={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        bgcolor="grey.50"
      >
        <Typography variant="overline" color="text.secondary">
          {props.title}
        </Typography>
        {props.chip && (
          <Chip
            size="small"
            color="primary"
            variant="outlined"
            label={props.chip}
          />
        )}
      </Stack>
      <Divider />
      {props.children}
    </Paper>
  );
}
